import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfMissionImpressionGenratedAction = createAsyncThunk(
    'no-of-mission-impression-granted',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/no-of-mission-impression-granted?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfMissionImpressionGenratedSlice = createSlice({
    name: 'no-of-mission-impression-granted',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfMissionImpressionGenratedAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfMissionImpressionGenratedAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfMissionImpressionGenratedAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfMissionImpressionGenratedReducer = noOfMissionImpressionGenratedSlice.reducer
